import React from "react"
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";

import { getP24TransactionStatusById } from "../../../constants/P24TransactionStatus";
import { getP24TransactionRefundStatusById } from "../../../constants/P24TransactionRefundStatus";

import P24RestaurantChequeTransactionFilter from "../../../components/p24/P24RestaurantChequeTransactionFilter";

import { fetchP24RestaurantChequeTransactionsByFilter } from "../../../actions/p24RestaurantChequeTransactionActions";
import LoadingTable from "../../../components/LoadingTable";

import { formatDateTime, formatDate, formatMoneyDiv100 } from "../../../helpers/utils";

/**
 * Komponent reprezentujący transakcje P24 dla konkretnej restauracji
 */
class P24RestaurantChequeTransactions extends React.Component {

    componentDidMount() {
        //ladowanie danych do tabeli - przy inicjalizacji komponentu
        this.props.fetchP24RestaurantChequeTransactionsByFilter(this.props.restaurantId, this.props.p24RestaurantChequeTransactionFilter);
    }

    /**
   * Globalna metoda tłumacząca
   * 
   * @param {String} key klucz to tłumaczeń 
   * @param {Object} params obiekt z parametrami do tłumaczenia
   */
    formatMessage = (key, params) => {
        return this.props.intl.formatMessage({ id: key }, params);
    };

    /**
   * Kolumny do tabelki
   */
    tableColumns = [
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.id"),
            accessor: "id",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 50
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.chequeTransactionUuid"),
            accessor: "chequeTransactionUuid",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 100
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.amount"),
            id: "amount",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' },
            accessor: (data) => formatMoneyDiv100(data.amount),
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.email"),
            accessor: "email",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.description"),
            accessor: "description",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.blikCode"),
            accessor: "blikCode",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.p24Status"),
            id: "p24Status",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' },
            accessor: data => getP24TransactionStatusById(data.p24Status).displayText,
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.refundTotalAmount"),
            id: "refundTotalAmount",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' },
            accessor: (data) => formatMoneyDiv100(data.refundTotalAmount),
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.refundDescription"),
            accessor: "refundDescription",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.p24RefundStatus"),
            id: "p24RefundStatus",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' },
            accessor: data => getP24TransactionRefundStatusById(data.p24RefundStatus).displayText,
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.creationDate"),
            id: "creationDate",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return formatDateTime(data.creationDate);
            }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.chequeId"),
            accessor: "chequeId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 150
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.chequeNumber"),
            accessor: "chequeNumber",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' },
            maxWidth: 80
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.chequeName"),
            accessor: "chequeName",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.saleDayId"),
            accessor: "saleDayId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.saleDayDate"),
            id: "saleDayDate",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return formatDate(data.saleDayDate);
            }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.posId"),
            accessor: "posId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 50
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.posName"),
            accessor: "posName",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.posHardwareId"),
            accessor: "posHardwareId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.userId"),
            accessor: "userId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.userName"),
            accessor: "userName",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },

        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.refundPosId"),
            accessor: "refundPosId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 50
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.refundPosName"),
            accessor: "refundPosName",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.refundPosHardwareId"),
            accessor: "refundPosHardwareId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.refundUserId"),
            accessor: "refundUserId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.refundUserName"),
            accessor: "refundUserName",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },


        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.contractorName"),
            accessor: "contractorName",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24RestaurantChequeTransaction.contratorNip"),
            accessor: "contratorNip",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },

    ];

    /**
     * Obsluga zmiany filtra
     */
    onFilterChange = () => {
        //ladowanie danych do tabeli - po aktualizacji filtra
        this.props.fetchP24RestaurantChequeTransactionsByFilter(this.props.restaurantId, this.props.p24RestaurantChequeTransactionFilter);
    }

    render() {
        return (
            <div>
                <h3>Transakcje rachunkowe P24 wybranej restauracji</h3>


                <P24RestaurantChequeTransactionFilter onFilterChange={this.onFilterChange} />

                <br />

                <LoadingTable
                    data={this.props.p24RestaurantChequeTransactionList}
                    columns={this.tableColumns}
                    loading={false}
                />


                <br /><br /><br />
            </div>
        )
    }
}

P24RestaurantChequeTransactions.propTypes = {
    //identyfikator restauracji
    restaurantId: PropTypes.number.isRequired
}

const mapStateToProps = state => ({
    p24RestaurantChequeTransactionFilter: state.p24RestaurantChequeTransactionReducer.p24RestaurantChequeTransactionFilter,
    p24RestaurantChequeTransactionList: state.p24RestaurantChequeTransactionReducer.p24RestaurantChequeTransactionList,
});


const mapDispatchToProps = ({
    fetchP24RestaurantChequeTransactionsByFilter: fetchP24RestaurantChequeTransactionsByFilter
});

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
);

export default compose(
    withConnect,
    injectIntl
)(P24RestaurantChequeTransactions);